import React, { useState } from 'react';
import { Button } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import { useAuth } from '../../../assets/utils/useAuth';
import { canDownloadClaimsSheet, claimsSheetLabel, downloadClaimsSheet } from '../claimsExportHelpers';

/**
 * Excel download for a payment drill-down level. Renders nothing where the
 * spec gives that stage/level no download (see claimsSheetLabel).
 */
const ClaimsSheetButton = ({ segment, level, month, facilityId, size = 'small', disabled = false }) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const label = claimsSheetLabel(segment, level);
  if (!label || !canDownloadClaimsSheet(user)) return null;

  const onClick = async () => {
    setLoading(true);
    try {
      await downloadClaimsSheet({ segment, level, month, facilityId });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button icon={<FileExcelOutlined />} onClick={onClick} loading={loading} disabled={disabled} size={size}>
      {label}
    </Button>
  );
};

export default ClaimsSheetButton;
